import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { agents } from '../../data/agents';
import { blandCalls } from '../../data/blandCalls';
function Outcome({
  ok,
  label
}: {
  ok: boolean;
  label: string;
}) {
  const Icon = ok ? CheckIcon : MinusIcon;
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-1.5 py-0.5 text-[11px] font-medium ${ok ? 'bg-src-bland-soft text-src-bland' : 'bg-canvas text-subtle'}`} data-id="element-56" data-mp="piqt73jege9m">
      <Icon className="h-3 w-3" aria-hidden data-id="element-57" data-mp="3syxk09gpuh0z" />
      {label}
    </span>;
}
export function BlandRecentCalls() {
  return <section aria-labelledby="bland-recent-heading" className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 shadow-card" data-id="element-58" data-mp="1s4onm8ltc4d">
      <h2 id="bland-recent-heading" className="text-base font-semibold text-ink" data-id="element-59" data-mp="6pwdu8hv6k4v">
        Latest AI calls
      </h2>
      <p className="text-xs text-muted" data-id="element-60" data-mp="1i75tsl1sau1f">Outcome of each dial</p>
      <ul className="mt-3 divide-y divide-line" data-id="element-61" data-mp="1i5l2d4arnr7s">
        {blandCalls.map(c => {
        const lo = c.transferredTo ? agents.find(a => a.id === c.transferredTo) : undefined;
        return <li key={c.id} className="py-2.5" data-id="element-62" data-mp="1vqnse19pa26k">
              <div className="flex items-baseline justify-between gap-3" data-id="element-63" data-mp="1qsw2tdwj2s5j">
                <p className="truncate text-sm font-semibold text-ink" data-id="element-64" data-mp="1luks70yesdm9">{c.contact}</p>
                <span className="shrink-0 text-xs text-subtle" data-id="element-65" data-mp="1lwyk50xsl9pl">{c.time}</span>
              </div>
              <div className="mt-1.5 flex flex-wrap gap-1.5" data-id="element-66" data-mp="1gxc98y5fs5jy">
                <Outcome ok={c.pickedUp} label={c.pickedUp ? 'Picked up' : 'No answer'} data-id="element-67" data-mp="1c3zmyuo8caud" />
                {c.pickedUp && <Outcome ok={!!lo} label={lo ? `To ${lo.name}` : 'Not transferred'} data-id="element-68" data-mp="183pf1cgvnacv" />}
                {lo && <Outcome ok={c.opportunity} label={c.opportunity ? 'Opportunity' : 'No opportunity'} data-id="element-69" data-mp="135e38w70ups0" />}
              </div>
            </li>;
      })}
      </ul>
    </section>;
}